import { render, staticRenderFns } from "./AlliancesModule.vue?vue&type=template&id=37afa6d7&scoped=true&"
import script from "./AlliancesModule.vue?vue&type=script&lang=js&"
export * from "./AlliancesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37afa6d7",
  null
  
)

export default component.exports